<script lang="ts" setup>
import { initials } from '@ubi/js-utils/utils'
import { useAuthStore } from '@/plugins/auth'
import { usePermissionStore } from '@/plugins/permission/permissionStore'
import type { RouteName } from '@/plugins/permission/types'
import LocaleSelector from './LocaleSelector.vue'

type PageDescription = {
    label: string
    name: RouteName
}

const { logout, tokenData } = useAuthStore()
const { hasAccess } = usePermissionStore()

const allPages = computed<PageDescription[]>(() => [
    {
        label: $t('ca.default.customers'),
        name: '/customers/',
    },
    {
        label: $t('ca.default.incidents'),
        name: '/incidents/',
    },
    {
        label: $t('ca.default.parameters'),
        name: '/parameters/',
    },
    {
        label: $t('ca.default.services'),
        name: '/services/',
    },
    {
        label: $t('ca.default.schemas'),
        name: '/schema-playground/',
    },
])

const availablePages = computed(() =>
    allPages.value.filter((page) => hasAccess(page.name))
)

const username = computed(() => {
    const data = tokenData()
    if (data.given_name && data.family_name) {
        return `${data.given_name} ${data.family_name}`
    } else if (data.given_name) {
        return data.given_name
    } else if (data.family_name) {
        return data.family_name
    }
    return data.username
})

const userInitials = computed(() => {
    return initials(username.value).toUpperCase()
})
</script>
<template>
    <VToolbar
        :title="$t('ca.default.configuration_app')"
        color="primary-darken-2"
    >
        <VToolbarItems>
            <template v-for="page of availablePages" :key="page.name">
                <VBtn :text="page.label" :to="page.name" :rounded="false" />
            </template>
            <LocaleSelector />
        </VToolbarItems>
        <VSpacer />
        <div class="d-flex align-center ga-4 me-6">
            <VBtn
                :text="$t('ca.default.logout')"
                color="error"
                variant="flat"
                size="small"
                @click="logout"
            />
            <VAvatar :title="username" color="primary">
                {{ userInitials }}
            </VAvatar>
        </div>
    </VToolbar>
</template>
